import { render, staticRenderFns } from "./nr-attachment-edit.vue?vue&type=template&id=00a5d9be&scoped=true"
import script from "./nr-attachment-edit.vue?vue&type=script&lang=ts"
export * from "./nr-attachment-edit.vue?vue&type=script&lang=ts"
import style0 from "./nr-attachment-edit.vue?vue&type=style&index=0&id=00a5d9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5d9be",
  null
  
)

export default component.exports